import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const CustomerReferralCode = ApplicationRecord.extend({
  attrs: {
    code: attr(),
    customer_id: attr(),
  },
  static: {
    endpoint: '/customer_referral_codes',
    jsonapiType: 'vouchers-customer_referral_codes',
  },
});

export default CustomerReferralCode;
